import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { AppAutocomplete } from "./app-autocomplete/app-autocomplete.tsx";
import { AutocompleteProvider } from "./app-autocomplete/providers/AutocompleteProvider.tsx";
import { AlgoliaShopConfigProvider } from "./providers/AlgoliaShopConfigProvider.tsx";
window.addEventListener("load", () => {
	const rootElement = document.getElementById("algolia-autocomplete");
	if (rootElement) {
		const rootNode = createRoot(rootElement);
		rootNode.render(
			<StrictMode>
				<AlgoliaShopConfigProvider domElement={rootElement}>
					<AutocompleteProvider>
						<AppAutocomplete/>
					</AutocompleteProvider>
				</AlgoliaShopConfigProvider>
			</StrictMode>
		);
	}
});
